<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.SelectCabinetData')"
    width="800px"
    :close-on-click-modal="false"
    class="app-main-inner"
    append-to-body
  >
    <cargo-ag-grid
      :show-side-bar="false"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      style="width:100%;height:300px"
      @gridReady="params=>gridApi=params.api"
    />
    <span slot="footer">
      <el-button type="primary" no="1" @click="saveHandler">{{ $t('SeaExport.Confirm') }}</el-button>
      <el-button no="2" @click="innerVisible=false">{{ $t('SeaExport.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

import ColumnUtils from '@/utils/ColumnUtils'
import { queryTruckingByJob } from '@/api/seaExport/containerTruckingRecord'

export default {
  name: 'TabContainerRecordLinkDialog',
  components: { },
  props: {
    visible: { type: Boolean, required: true },
    jobUuid: { type: String, required: false }
  },
  data() {
    return {
      innerVisible: false,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('SeaExport.ContainerId'),
          field: 'containerId',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.ContainerSize'),
          field: 'eqSize',
          width: 70
        },
        {
          headerName: this.$t('SeaExport.ContainerType'),
          field: 'eqType',
          width: 70
        },
        {
          headerName: this.$t('SeaExport.ContainerNo'),
          field: 'containerNo',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.SealNo'),
          field: 'sealNo',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.DriverName'),
          field: 'driverName',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.DriverPhone'),
          field: 'driverPhone',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.TruckNo'),
          field: 'truckNo',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.ContainerWeight'),
          field: 'containerWeight',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.truckingPlaceDest'),
          field: 'truckingPlaceOfDest',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.EstimatArrivalTime'),
          field: 'estimatedArrivalTime',
          width: 160,
          cellRenderer: (params) => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Quantity'),
          field: 'quantity',
          width: 70,
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.GrossWeight'),
          field: 'weight',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Cubage'),
          field: 'cubage',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.TrailerRemark'),
          field: 'trailerRemark',
          width: 120
        }
      ],
      rowData: [],
      gridApi: null,
      selectedData: {}
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.queryHandler()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.queryHandler()
    }
  },
  methods: {
    async queryHandler() {
      await queryTruckingByJob({ jobUuid: this.jobUuid }).then(res => {
        this.rowData = res.data
      })
    },
    saveHandler() {
      const containerRecords = this.gridApi.getSelectedRows()
      this.innerVisible = false
      this.$emit('selectTruckingRecordHandler', containerRecords)
    }
  }
}
</script>

<style>
</style>
